module.exports = __webpack_public_path__ + "img/partner-triptangkahan.5cad5480.png";